import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Segment } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { SelectWidget, TextWidget } from '@plone/volto/components';
import { useIntl, defineMessages } from 'react-intl';
import { getVocBookingTypes } from '@redturtle/volto-io-prenoto/actions/booking';
import { getBaseUrl } from '@plone/volto/helpers';

const messages = defineMessages({
  label_default_booking_button: {
    id: 'Prenota appuntamento',
    defaultMessage: 'Prenota appuntamento',
  },
  label_default_booking_type: {
    id: 'Tipologia di prenotazione',
    defaultMessage: 'Tipologia di prenotazione',
  },
});

const Sidebar = (props) => {
  const dispatch = useDispatch();
  const { data, block, onChangeBlock, pathname } = props;
  const intl = useIntl();
  const path = getBaseUrl(pathname);
  const vocBookingTypes = useSelector((state) =>
    (state.vocBookingTypes?.result?.items || []).map((item) => [
      item.token,
      item.title,
    ]),
  );

  useEffect(() => {
    dispatch(getVocBookingTypes(path));
  }, []);

  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage
            id="bookingButton"
            defaultMessage="Bottone prenotazioni"
          />
        </h2>
      </header>

      <Segment className="form sidebar-listing-data">
        <TextWidget
          id="title"
          title="Testo del bottone"
          value={
            data.title ??
            intl.formatMessage(messages.label_default_booking_button)
          }
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />
        <SelectWidget
          id="booking_type"
          title={intl.formatMessage(messages.label_default_booking_type)}
          value={data.booking_type}
          choices={vocBookingTypes}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />
      </Segment>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Sidebar;
